import {
  GETTER_PRODUCT_PRINT_AREA,
  GETTER_PRODUCT_PRINT_PLATE
} from './modules/product/getters';
import {
  GETTER_COMPOSITION_COMPOSITION,
  GETTER_COMPOSITION_PRINT_STYLE
} from './modules/composition/getters';
import capabilities from './capabilities';

export const GETTER_ACTIVE_PRINT_SIDE = 'activePrintSide';
export const GETTER_ACTIVE_PRINT_SIDE_PRINT_STYLE = 'activePrintSidePrintStyle';
export const GETTER_ACTIVE_PRINT_PLATE_HEIGHT_MM = 'activePrintPlateHeightInMm';
export const GETTER_AVAILABLE_PRINT_STYLES_BY_PRINT_SIDE =
  'availablePrintStylesByPrintSide';
export const GETTER_ACTIVE_PRINT_SIDE_AVAILABLE_PRINT_STYLES =
  'activePrintSideAvailablePrintStyles';
export const GETTER_ACTIVE_PRINT_SIDE_PRINT_PLATE = 'activePrintSidePrintPlate';
export const GETTER_SHOW_NAVIGATION = 'showNavigation';
export const GETTER_PRODUCT_CHANGE_ENABLED = 'productChangeEnabled';

const getSelectedCount = filterCategory => {
  if (
    typeof filterCategory !== 'object' ||
    !Object.prototype.hasOwnProperty.call(filterCategory, 'filters')
  ) {
    return 0;
  }
  return Object.keys(filterCategory.filters).filter(
    filter => filterCategory.filters[filter].selected
  ).length;
};

export default {
  ...capabilities,
  totalPrice: state =>
    state.basket.items
      .map(product => state.product.price * product.quantity)
      .reduce((total, num) => total + num, 0),
  selectedCountByCategory: state => category =>
    getSelectedCount(state.filters[category]),
  filterCountTotal: state =>
    Object.keys(state.filters).reduce(
      (prev, cur) => prev + getSelectedCount(state.filters[cur]),
      0
    ),
  [GETTER_ACTIVE_PRINT_SIDE]: state => state.activePrintSide,
  [GETTER_ACTIVE_PRINT_SIDE_PRINT_STYLE]: (state, getters) =>
    getters[GETTER_COMPOSITION_PRINT_STYLE](getters[GETTER_ACTIVE_PRINT_SIDE]),
  [GETTER_AVAILABLE_PRINT_STYLES_BY_PRINT_SIDE]: (state, getters) => side => {
    try {
      return getters[GETTER_PRODUCT_PRINT_AREA](side).availablePrintStyles;
    } catch (e) {
      return [];
    }
  },
  [GETTER_ACTIVE_PRINT_SIDE_AVAILABLE_PRINT_STYLES]: (state, getters) =>
    getters[GETTER_AVAILABLE_PRINT_STYLES_BY_PRINT_SIDE](
      getters[GETTER_ACTIVE_PRINT_SIDE]
    ),
  [GETTER_ACTIVE_PRINT_PLATE_HEIGHT_MM]: (state, getters) =>
    getters[GETTER_PRODUCT_PRINT_PLATE](getters[GETTER_ACTIVE_PRINT_SIDE])
      .heightInInch * 25.4,
  [GETTER_ACTIVE_PRINT_SIDE_PRINT_PLATE]: (state, getters) =>
    getters[GETTER_COMPOSITION_COMPOSITION].printPlates[
      getters[GETTER_ACTIVE_PRINT_SIDE]
    ],
  [GETTER_SHOW_NAVIGATION]: state => state.showNavigation,
  [GETTER_PRODUCT_CHANGE_ENABLED]: state => state.productChangeEnabled
};
